import { ClientAreaApiClient, UserActivityDto } from 'common/api/autogenerated/client-area';

const clientAreaApiClient = new ClientAreaApiClient({
  BASE: '/client-area',
  WITH_CREDENTIALS: true,
});

export const sentUserLocation = (data: UserActivityDto) => clientAreaApiClient.userActivity.postApiUserActivities(data);
